import type { EventWithLocations } from "@/components/RegistrationProcess/types/events.ts";

/**
 * Duration line for excursion cards and detail modals, in the CMS-configured unit
 * (Hours/Days/Weeks/Months) rather than a fixed one.
 * Units are rendered in the "(s)" form the flag-off cards use, and an event missing
 * either half returns "" so callers drop the row instead of showing a zero.
 */
export const getEventDuration = (event: Partial<EventWithLocations> | null | undefined): string => {
  const duration = event?.duration;
  const units = event?.duration_units;

  if (!duration || !units) {
    return "";
  }

  const unitLabel = units.endsWith("s") ? `${units.slice(0, -1)}(s)` : units;

  return `${duration} ${unitLabel}`;
};
